// extracted by mini-css-extract-plugin
module.exports = {"municipalityDetail":"_3wDu5ColfGp7T-nGwMzgWk","caption":"_3YU6uIdkDNozYldrjj4Eq8","header":"_1kzSdMC5utBVy_2MMMuiNO"};